module.exports = __webpack_public_path__ + "img/icon_thematic.e721ca57.png";